module.exports = __webpack_public_path__ + "static/media/popsicle-screenshot-3.a3c20997.png";